import React from 'react';
import {connect} from 'react-redux';
import {modal} from 'react-redux-modal';
import SignUp from '../SignUp';
import ForgotPasswordForm from '../../Forms/ForgotPassword';


import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class ForgotPasswordComponent extends React.Component {
  constructor(props){
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.signUp = this.signUp.bind(this);
    this.toolTip = this.toolTip.bind(this);
    this.state = {
      submitted: false
    };
  }

  componentDidMount(){
    modalViewGA('forgot-password');
  }

  closeModal(e){
    e.preventDefault();
    this.props.removeModal();
  }

  signUp(e){
    e.preventDefault();
    this.closeModal(e);
    modal.add(SignUp, {title:'', size:'medium', hideTitleBar:true})
  }

  toolTip(e){
    e.preventDefault();
  }

  render(){
    return (
      <div>
        <div className="modals-popup forgot-password-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Password Reset</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={this.closeModal}></a>
            </div>
          </div>

          <div className="info">
          <div className="p-20">
            <ForgotPasswordForm removeModal={this.props.removeModal} />
          </div>
          </div>

          <div className="modal-footer">
            <div className="other-action">
              <a href="#" className="u-fontSize-11" onClick={this.signUp}><span>Not a member? Sign Up</span><span className="arw"></span></a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
  };
}

export default connect(mapStateToProps)(ForgotPasswordComponent);
